import { render, staticRenderFns } from "./LeagueRanking.vue?vue&type=template&id=c82b01bc&"
import script from "./LeagueRanking.vue?vue&type=script&lang=js&"
export * from "./LeagueRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports